// extracted by mini-css-extract-plugin
export default {"bg":"LifeInsurance_bg__rSY-B","main":"LifeInsurance_main__DA8wj","left":"LifeInsurance_left__hjM5C","right":"LifeInsurance_right__HjgHs"};